import Tooltip from "@mui/material/Tooltip";

const TruncateDescription = ({value}) => {
	const fullText = value || '';
	const truncatedText = fullText.length > 250 ? fullText.substring(0, 250) + '...' : fullText;
	return (
		<Tooltip title={fullText}>
			<span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
			  {truncatedText}
			</span>
		</Tooltip>
	);
};

export default TruncateDescription